<template>
  <hic-list-page title="费用标准项目" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码" :search-fields="searchFields">
    <template slot="buttons">
      <el-dropdown split-button type="primary" @click="create" size="small" @command="menuCmd">
        <i class="el-icon-plus" /> 新建
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batch">批量更新 <i class="el-icon-more-outline" /></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <el-table-column label="操作" width="100" align="center" fixed="left">
      <template #default="scope">
        <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />
        <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" width="120" fixed="left" sortable="custom">
      <template #default="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="项目内容" prop="inclusion" min-width="400">
      <template slot-scope="{ row }">
        {{ row.inclusion }}
        <b v-if="row.ifType">费用标准分类：{{ row.name }}</b>
        <span v-if="row.exclusion" class="warning"><br /><b class="danger">除外内容：</b>{{ row.exclusion }}</span>
        <span v-if="row.memo" class="info"><br /><b class="danger">备注：</b>{{ row.memo }}</span>
      </template>
    </el-table-column>
    <el-table-column label="单位" prop="unit" width="80" align="center" />
    <el-table-column label="价格" prop="price" width="150" align="right" sortable="custom">
      <template slot-scope="{ row }">
        <span v-if="!row.ifType" class="danger">{{ row.price | fmtFloat }}</span>
        <div v-if="row.priceMemo" class="left"><b>备注：</b>{{ row.priceMemo }}</div>
      </template>
    </el-table-column>
    <el-table-column label="标准类别" prop="standardClass" :filter-multiple="false" :filters="dict.FeeStandardClass" column-key="standardClass" width="150" align="center">
      <template #default="{ row }">
        {{ row.standardClass | dictText("FeeStandardClass") }}
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" width="150" sortable="custom" />
    <el-table-column label="报销类别" prop="reimburseCategory" :filter-multiple="false" :filters="dict.ReimburseCategory" column-key="reimburseCategory" width="100" align="center">
      <template #default="{ row }">
        {{ row.reimburseCategory | dictText("ReimburseCategory") }}
      </template>
    </el-table-column>
    <el-table-column label="工伤报销" prop="injuryReimburseCategory" :filter-multiple="false" :filters="dict.ReimburseCategory" column-key="injuryReimburseCategory" width="100" align="center">
      <template #default="{ row }">
        {{ row.injuryReimburseCategory | dictText("ReimburseCategory") }}
      </template>
    </el-table-column>
    <el-table-column label="统计类型" prop="statisticType" :filter-multiple="false" :filters="dict.FeeStatisticType" column-key="statisticType" width="150" align="center">
      <template #default="{ row }">
        {{ row.statisticType | dictText("FeeStatisticType") }}
      </template>
    </el-table-column>
    <el-table-column label="门诊结算类型" prop="opFeeType" :filter-multiple="false" :filters="dict.FeeType" column-key="opFeeType" width="150" align="center">
      <template #default="{ row }">
        {{ row.opFeeType | dictText("FeeType") }}
      </template>
    </el-table-column>
    <el-table-column label="住院结算类型" prop="ipFeeType" :filter-multiple="false" :filters="dict.FeeType" column-key="ipFeeType" width="150" align="center">
      <template #default="{ row }">
        {{ row.ipFeeType | dictText("FeeType") }}
      </template>
    </el-table-column>
    <!-- <el-table-column label="启用日期" prop="startDate" width="150" align="center">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column label="停用日期" prop="endDate" width="150" align="center">
      <template slot-scope="{ row }">
        {{ row.feeType | fmtDate }}
      </template>
    </el-table-column> -->
    <el-table-column label="停用" prop="disabled" :filter-multiple="false" :filters="$utils.Dict.bool()" column-key="disabled" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.disabled" type="danger" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="分类标志" prop="ifType" :filter-multiple="false" :filters="$utils.Dict.bool()" column-key="ifType" width="100" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifType" type="primary" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="文件依据" prop="paper" width="150" />
    <el-table-column label="国标" prop="gbCode" align="left">
      <template #default="{ row }">
        <span v-if="row.gbCode">{{ row.gbCode }}</span>
        <span v-if="row.gbName"><br />{{ row.gbName }}</span>
      </template>
    </el-table-column>
    <Edit :visible.sync="showEditor" v-model="entity" @ok="page" />
    <BatchEdit :visible.sync="showBatch" v-model="entity" @ok="page" :con="condition" />
  </hic-list-page>
</template>

<script>
  import api from "./api.js";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      Edit: () => import("./edit"),
      BatchEdit: () => import("./batchEdit"),
    },
    data() {
      return {
        showEditor: false,
        showRoles: false,
        showBatch: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          sort: "id",
          asc: true,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        meta: {
          loading: false,
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "permission", "dictEnum"]),
      searchFields() {
        if (!this.dict) {
          return;
        }
        return [
          { label: "标准类别", prop: "standardClass", type: "dict", options: this.dict.FeeStandardClass },
          { label: "统计类型", prop: "statisticType", type: "dict", options: this.dict.FeeStatisticType },
          { label: "门诊结算类型", prop: "opFeeType", type: "dict", options: this.dict.FeeType },
          { label: "住院结算类型", prop: "ipFeeType", type: "dict", options: this.dict.FeeType },
          { label: "医保报销类别", prop: "reimburseCategory", type: "dict", options: this.dict.ReimburseCategory },
          { label: "工伤报销类别", prop: "injuryReimburseCategory", type: "dict", options: this.dict.ReimburseCategory },
          { label: "停用", prop: "disabled", type: "dict", options: this.$utils.Dict.bool() },
          { label: "分类标志", prop: "ifType", hide: true },
        ];
      },
    },
    methods: {
      page() {
        this.meta.loading = true;
        api.FeeStandard.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      create() {
        this.entity = {
          id: null,
        };
        this.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.showEditor = true;
      },
      del(row, index) {
        api.FeeStandard.del(row.id).then((res) => {
          this.entities.items.splice(index, 1, {});
          this.$message.success("删除成功！");
        });
      },
      menuCmd(cmd) {
        if (cmd == "batch") {
          this.entity = {}
          this.showBatch = true;
        }
      },
    },
  };
</script>
